import classNames from "classnames";
import * as React from "react";
import { FadeInText } from "source/app/presentation/Shared/Animation/FadeInArray";
import { Style } from "source/app/presentation/Shared/Styles/CSS";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Hyperlink from "../../../presentation/Shared/Link/Hyperlink";
import { Sounds } from "../../Sound/Sounds";
import { TCSS } from "../../../presentation/Shared/Styles/CSS";
import { HowlerSoundFile } from "source/app/services/Sound/HowlerSoundFile";
import { TouchActionButton } from "source/app/presentation/Shared/TouchActionButton/TouchActionButton";
const styles = require("./IconWithText.css");

const IconWithText = ({
    iconSuffix,
    whenClicked,
    children,
    displayAsBlock,
    notALink,
    withClass,
    tooltip,
    ariaLabel,
    customStyle,
    innerStyleClass,
    linkClass,
    customSound,
    fadeInText = true,
    useButton = false,
    activateOnPointerUp = false,
}: IconWithTextOptions) => {
    const ClickWithSound = () => {
        const soundToPlay = customSound ?? Sounds.wooden_tap;
        soundToPlay.Play({ allowConcurrent: true, volume: 0.6 });
        whenClicked();
    };

    const text = children ? children : "";

    const IconWithTextContent = () => (
        <span
            {...Style(`inline-block`, {
                display: `inline-block`,
            })}
            className={innerStyleClass}
            data-tip={tooltip}
            key={text}
        >
            <Glyphicon icon={iconSuffix} />
            <span className={children ? styles.iconText : ""}>
                {fadeInText ? (
                    <FadeInText text={text} characterDelayMs={40} key={text} />
                ) : (
                    text
                )}
            </span>
        </span>
    );

    const UsingLink = () =>
        useButton ? (
            <TouchActionButton
                ariaLabel={ariaLabel}
                className={linkClass}
                onActivate={ClickWithSound}
                activateOnPointerUp={activateOnPointerUp}
            >
                <IconWithTextContent />
            </TouchActionButton>
        ) : (
            <Hyperlink
                ariaLabel={ariaLabel}
                classes={linkClass}
                whenClicked={ClickWithSound}
            >
                <IconWithTextContent />
            </Hyperlink>
        );

    const NotUsingLink = () => (
        <TouchActionButton
            ariaLabel={ariaLabel}
            title={tooltip}
            className={linkClass}
            onActivate={ClickWithSound}
            activateOnPointerUp={activateOnPointerUp}
        >
            <Glyphicon icon={iconSuffix} />
            <span className={children ? styles.iconText : ""}>{children}</span>
        </TouchActionButton>
    );

    const mainStyle = withClass ? withClass : styles.iconMain;

    return (
        <span
            className={classNames([mainStyle], {
                // [styles.ifDesktop]: !IsMobileDevice(),
                [styles.displayBlock]: displayAsBlock,
            })}
            style={{ ...customStyle }}
        >
            {notALink ? <NotUsingLink /> : <UsingLink />}
        </span>
    );
};

export default IconWithText;

interface IconWithTextOptions {
    id?: string;
    iconSuffix: EGlyphicon;
    whenClicked: Function;
    whenDoubleClicked?: Function;
    children?: string;
    displayAsBlock: boolean;
    notALink?: boolean;
    withClass?: string;
    tooltip?: string;
    ariaLabel?: string;
    customStyle?: TCSS;
    innerStyleClass?: string;
    linkClass?: string;
    customSound?: HowlerSoundFile;
    fadeInText?: boolean;
    useButton?: boolean;
    activateOnPointerUp?: boolean;
}
